/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_ProInputs */

const en_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fr_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const de_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const it_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionista`)
};

const ru_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про`)
};

const es_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const zh_cn2_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版`)
};

const ja_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロ`)
};

const hi_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रो`)
};

const pt_pt2_signup_plan_pro = /** @type {(inputs: Signup_Plan_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pró`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Signup_Plan_ProInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_pro = /** @type {((inputs?: Signup_Plan_ProInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_ProInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_plan_pro(inputs)
	if (locale === "de") return de_signup_plan_pro(inputs)
	if (locale === "it") return it_signup_plan_pro(inputs)
	if (locale === "ru") return ru_signup_plan_pro(inputs)
	if (locale === "es") return es_signup_plan_pro(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_plan_pro(inputs)
	if (locale === "ja") return ja_signup_plan_pro(inputs)
	if (locale === "hi") return hi_signup_plan_pro(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_plan_pro(inputs)
	return en_signup_plan_pro(inputs)
});